export class AgentCurrencyDto {

    Id: string;
    AgentId: string;
    CurrencyName: string;
    CurrencyId: number;
    TreasuryNumber: string
    CreationDate: Date;
    ModifiedDate: Date;
    CreatedBy: string;
    ModifiedBy: string
    IsDeleted: boolean;
}

export class AgentCurrencyListDto {
    RequestId: string;
    AgentId: string;
    AdminEmail: string;
    AgentCurrencyDto: AgentCurrencyDto[] = [];
}